module.exports = __webpack_public_path__ + "static/media/ambAvatar.0bba76b2.png";